import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { getOr } from 'lodash/fp';
import qs from 'query-string';

import {
  ANDROID_PACKAGE, HOST_URL, APP_STORE_URL, PLAY_STORE_URL,
} from '../../../constants';
import { Spinner } from '../../../components';
import { daumtools } from '../../../utils';
import * as tokenActions from '../../token/actions';
import {
  Header, OpenLink, OpenLinkError, OpenLinkExpired,
} from '../components';

const S = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
  `,
  Main: styled.main`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  `,
};

const Entry = ({ match }) => {
  const guardianContactNewsletter = useSelector((state) => state.token.guardianContactNewsletter, shallowEqual);

  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    const sid = getOr('', 'school.sid', guardianContactNewsletter.data);
    const nid = getOr('', 'newsletter_id', guardianContactNewsletter.data);
    const gcid = getOr('', 'guardian_contact.id', guardianContactNewsletter.data);

    const encodedURI = encodeURIComponent(guardianContactNewsletter.data
      ? `${HOST_URL}/schools/${sid}/school-newsletters/${nid}?${qs.stringify({ gcid, token: match.params.token })}`
      : `${HOST_URL}/school-newsletters`);

    const ua = daumtools.userAgent();
    const url = `classting://link?hide_navi=1&zoom=1&url=${encodedURI}`;

    const getInstallURL = () => {
      if (ua.os.android) {
        return PLAY_STORE_URL;
      }

      if (ua.os.ios) {
        return APP_STORE_URL;
      }

      return window.location.href;
    };

    // XXX: iOS에서 앱이 설치되어있음에도 앱스토어가 열리는 문제
    const options = {
      urlScheme: url,
      intentURI: `intent://link?hide_navi=1&zoom=1&url=${encodedURI}#Intent;scheme=classting;package=${ANDROID_PACKAGE};end`,
      appName: 'classting',
      storeURL: getInstallURL(),
      onUnsupportedEnvironment: () => {},
    };

    daumtools.web2app(options);
  }, [guardianContactNewsletter.data, match.params.token]);

  const parseNewsletterToken = useCallback(() => dispatch(tokenActions.parseNewsletterTokenRequest({ token: match.params.token })), [dispatch, match.params.token]);
  const clearGuardianContactNewsletter = useCallback(() => dispatch(tokenActions.clearGuardianContactNewsletter()), [dispatch]);

  const handleRetry = () => {
    clearGuardianContactNewsletter();
    parseNewsletterToken();
  };

  useEffect(() => {
    parseNewsletterToken();
  }, [parseNewsletterToken]);

  const render = () => {
    if (guardianContactNewsletter.error) {
      return <OpenLinkError onRetry={handleRetry} />;
    }

    if (guardianContactNewsletter.data) {
      return (
        <OpenLink
          guardianContactNewsletter={guardianContactNewsletter}
          onClick={handleClick}
        />
      );
    }

    return <OpenLinkExpired onClick={handleClick} />;
  };

  if (guardianContactNewsletter.loading) {
    return <Spinner />;
  }

  return (
    <S.Wrapper>
      <Header />
      <S.Main>
        {render()}
      </S.Main>
    </S.Wrapper>
  );
};

Entry.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default Entry;
